export default __webpack_public_path__ + "static/media/about-team-matt-lanki.8a4b5326.png";